// Compare this snippet from src/components/SuperAdminParent/index.jsx:

const superAdminReducerDefaultState = {
  billingInformation: [],
}

export default (state = superAdminReducerDefaultState, action) => {
  switch (action.type) {
    case "SUPER_ADMIN::SET_BILLING_INFORMATION":
      return {
        ...state,
        billingInformation: action.data,
      }

    default:
      return state
  }
}
